'use client'

import { useQuery } from '@tanstack/react-query'

import { useSupabase } from '@/hooks'
import { useEncryptionKey } from '@/store'

import { getImage, GetImageArgs } from '../../actions'
import { queries } from '../../query-keys'

interface UseImageArgs {
  image: GetImageArgs['image']
  enabled?: boolean
}

const useImage = ({ image, enabled = true }: UseImageArgs) => {
  const client = useSupabase()
  const encryptionKey = useEncryptionKey()
  const query = useQuery({
    queryKey: queries.image(image.path).queryKey,
    queryFn: () => getImage({ client, image, encryptionKey }),
    enabled: !!encryptionKey && enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: Infinity, // Same input will always produce same output
    gcTime: 1000 * 60 * 5, // 5 minutes
  })

  return query
}

export default useImage
